import { Link } from 'react-router-dom';
import { t } from '../../i18n';
import { eurC } from '../../lib/money';
import { NoteRow } from '../belege/Bell';
import { useNotifications, useShared } from '../belege/shared';
import { rePath } from './labels';
import type { InvoicesResponse } from './types';

// Meldung „Neue Rechnung von Ihrer Kanzlei“ (oder zurückgezogen), bis sie geöffnet ist
export function RechnungenNotices() {
  const notes = useNotifications();
  const items = (notes.data?.items ?? []).filter((n) => n.type.startsWith('rechnung') && !n.read);
  if (!items.length) return null;
  return (
    <div className="notice" role="status">
      {items.map((n) => (
        <NoteRow key={n.id} item={n} />
      ))}
    </div>
  );
}

// Eintrag „Rechnungen“ in der Liste der Bereiche: offene mit Summe, „überfällig“ als Abzeichen
export function RechnungenListItem({ clientId }: { clientId: string }) {
  const res = useShared<InvoicesResponse>(`/api/app/invoices/${clientId}`, ['invoices', 'notifications', 'clients']);
  const items = res.data?.items ?? [];
  const open = items.filter((x) => x.status === 'offen');
  return (
    <Link className="item" to={rePath(clientId)}>
      <span className="ico" aria-hidden="true">
        €
      </span>
      <span className="tx">
        <b>{t('Rechnungen')}</b>
        <small>
          {open.length
            ? t('{n} offen · {amount}', { n: open.length, amount: eurC(res.data!.open) })
            : items.length
              ? t('Alle Rechnungen bezahlt')
              : t('Noch keine Rechnungen')}
        </small>
      </span>
      {open.some((x) => x.state === 'ueberfaellig') && <span className="badge b-warn">{t('überfällig')}</span>}
      <span className="chev" aria-hidden="true">
        ›
      </span>
    </Link>
  );
}
